module.exports = __webpack_public_path__ + "static/DHIPAYA.cf09746a.png";